import { createSlice } from "@reduxjs/toolkit";

export const selectedTutorSlice = createSlice({
  name: "tutor",
  initialState: { tutor: null },
  reducers: {
    set: (state, action) => {
      state.tutor = action.payload;
    },
  },
});

export const tutorActions = selectedTutorSlice.actions;
export default selectedTutorSlice;
